import { CHCRelatedLinks } from './related-links.component.js';
export { CHCRelatedLinks };

customElements.define('chcapp-related-links', CHCRelatedLinks);

declare global {
  interface HTMLElementTagNameMap {
    'chcapp-related-links': CHCRelatedLinks;
  }
}
